import { OnInit } from '@angular/core';
import { clearGisAuthRetryCounter } from '@app/modules/gis/gis-token';
import { GIS_PORTAL_BASE } from '@app/modules/gis/gis-config';
var GisAuthErrorComponent = /** @class */ (function () {
    function GisAuthErrorComponent() {
        this.portalUrl = GIS_PORTAL_BASE;
        this.supportEmail = 'GSC-EMIT-UIT-DISCOVERY-ASSESSMENT@exxonmobil.com';
    }
    GisAuthErrorComponent.prototype.ngOnInit = function () { };
    /**
     * Clear retry counter then do a full page reload to /geobrain.
     * Full reload is required so the guard runs fresh after state is cleared —
     * Angular router.navigate() fires the guard in the same page load without
     * clearing token state, causing an immediate loop back to this page.
     */
    GisAuthErrorComponent.prototype.retryAuthentication = function () {
        clearGisAuthRetryCounter();
        window.location.href = '/geobrain';
    };
    return GisAuthErrorComponent;
}());
export { GisAuthErrorComponent };
